import { Group, Skeleton, Stack, Text } from '@mantine/core';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTopVoucher } from '../../services/report-gamification';
import DataTables from '../../components/elements/DataTables';
import Card from '../../components/elements/Card';
import { defaultSizeTable } from '../../components/elements/DataTables/DataTables';

export default function TopVoucher() {
  const column = [
    {
      heading: 'Voucher Name',
      props: (item) => (
        <Text className="text-xs-medium">{item.voucherName || 'Unknown'}</Text>
      ),
      id: 'voucherName',
      sortable: true
    },
    {
      heading: 'Redeemed',
      props: (item) => (
        <Text className="text-xs-medium">{item.totalRedeem}x Redeem</Text>
      ),
      id: 'totalRedeem',
      sortable: true
    }
  ];

  const fetchedDataVoucher = useQuery({
    queryKey: [`topFrequencyRedeemVoucher`],
    queryFn: () => getTopVoucher(),
    enabled: true
  });

  const { data: dataFrequencyRedeem, isLoading } = fetchedDataVoucher;

  return (
    <Card flex={1} h={'100%'}>
      <Stack gap={'xs'}>
        <Group justify="space-between">
          <Text className="text-sm-semibold">Top Frequent Redeemed</Text>
          <Text className="text-xs-medium" c="gray">
            Last 30 days
          </Text>
        </Group>
        {isLoading && <Skeleton height={150} />}

        {!isLoading && (
          <DataTables
            columns={column}
            loading={false}
            data={dataFrequencyRedeem?.data?.data}
            sizing={[
              { label: '3', value: 3 },
              { label: '5', value: 5 },
              ...defaultSizeTable
            ]}
            activeSize={3}
          />
        )}
      </Stack>
    </Card>
  );
}
